

const INITIAL_STATE = {


name:'hassan',
hotel_data:[]
}






export default (state = INITIAL_STATE, action) => {
  

    
    
  console.log("pic>>>>",state);
  if(action.type=='hotel')
  
  {
      
      return({
        ...state,
        hotel_data:action.payload,
        
      })

    }
 

  return state; 
}